import { render } from "./Loader.vue?vue&type=template&id=a9156ac2"
const script = {}

const cssModules = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=a9156ac2&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/Users/mac_2/workspace/jukebox-goass/_neu/goass-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__